import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { DollarSign, Users, Globe, Star } from 'lucide-react';
function CountUp({
  end,
  prefix = '',
  suffix = '',
  decimals = 0
}: {
  end: number;
  prefix?: string;
  suffix?: string;
  decimals?: number;
}) {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const inView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  useEffect(() => {
    if (inView) {
      let start = 0;
      const duration = 1500;
      const fps = 60;
      const increment = end / (duration / (1000 / fps));
      const timer = setInterval(() => {
        start += increment;
        if (start >= end) {
          setCount(end);
          clearInterval(timer);
        } else {
          setCount(start);
        }
      }, 1000 / fps);
      return () => clearInterval(timer);
    }
  }, [inView, end]);
  const formatted = decimals > 0 ? count.toFixed(decimals) : Math.floor(count).toLocaleString('es-AR');
  return <span ref={ref} data-id="element-424">
      {prefix}
      {formatted}
      {suffix}
    </span>;
}
export function MetricsStrip() {
  return <section className="py-10 bg-graphite relative z-10 border-y border-white/5" data-id="element-425">
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
      backgroundImage: 'radial-gradient(#F5B942 1px, transparent 1px)',
      backgroundSize: '24px 24px'
    }} data-id="element-426"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-427">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-5xl mx-auto" data-id="element-428">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-petroleum/60 border border-electric/15 rounded-xl p-5 text-center flex flex-col items-center justify-center" data-id="element-429">
            <DollarSign className="w-6 h-6 text-energy mb-3" data-id="element-430" />
            <div className="text-2xl md:text-3xl font-extrabold text-white mb-1" data-id="element-431">
              <CountUp end={245000} prefix="USD " suffix="+" data-id="element-432" />
            </div>
            <div className="text-textsecondary text-[10px] md:text-xs uppercase tracking-wider font-semibold" data-id="element-433">
              Facturados por alumnos
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-petroleum/60 border border-electric/15 rounded-xl p-5 text-center flex flex-col items-center justify-center" data-id="element-434">
            <Users className="w-6 h-6 text-electric mb-3" data-id="element-435" />
            <div className="text-2xl md:text-3xl font-extrabold text-white mb-1" data-id="element-436">
              <CountUp end={1247} data-id="element-437" />
            </div>
            <div className="text-textsecondary text-[10px] md:text-xs uppercase tracking-wider font-semibold" data-id="element-438">
              Clientes cerrados
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-petroleum/60 border border-electric/15 rounded-xl p-5 text-center flex flex-col items-center justify-center" data-id="element-439">
            <Globe className="w-6 h-6 text-electric mb-3" data-id="element-440" />
            <div className="text-2xl md:text-3xl font-extrabold text-white mb-1" data-id="element-441">
              <CountUp end={38} data-id="element-442" />
            </div>
            <div className="text-textsecondary text-[10px] md:text-xs uppercase tracking-wider font-semibold" data-id="element-443">
              Países alcanzados
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="bg-petroleum/60 border border-electric/15 rounded-xl p-5 text-center flex flex-col items-center justify-center" data-id="element-444">
            <Star className="w-6 h-6 text-electric fill-electric mb-3" data-id="element-445" />
            <div className="text-2xl md:text-3xl font-extrabold text-white mb-1" data-id="element-446">
              <CountUp end={4.9} decimals={1} suffix=" / 5" data-id="element-447" />
            </div>
            <div className="text-textsecondary text-[10px] md:text-xs uppercase tracking-wider font-semibold" data-id="element-448">
              +500 reseñas verificadas
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}